const pluginsCheck = (type) =>
  Array.prototype.reduce.call(
    navigator.plugins,
    (supported, plugin) => supported || Array.prototype.reduce.call(plugin, (supportedq, mime) => supportedq || mime.type === type, supported),
    false,
  );

const imageCheck = (type) => type.startsWith('image/');

export default {
  mimeCheck: (type) => typeof type === 'string' && (pluginsCheck(type) || imageCheck(type)),
};
